import { FC } from "react";

import { TextBlock } from "components/base";

export const SummarySection: FC = () => (
  <section>
    <TextBlock>
      <h1>Трошки підсумки</h1>
      <p>
        Суб'єктивна думка на основі власного досвіду — основними лідерами серед
        самокатів є <b>Bolt</b> та <b>Jet</b>.
      </p>
      <p>
        <b>Bolt</b> універсальний вибір: найбільше покриття, постійна велика
        кількість доступних самокатів, варіативність моделей (хоча стара модель
        по всім параметрам краще нової, того вибір умовний).
      </p>
      <p>
        <b>Jet</b> гарний варіант коли потрібно дістатися кудись швидко. Їх
        самокати єдині які мають ліміт швидкості в 25 км/г (у інших 20 км/г). На
        жаль вони громіздкі та важкі (ті хто таскали їх по підземним переходам
        розуміють про що я). З іншого боку не думаю, що вони могли б підняти
        ліміт швидкості без такої ваги.
      </p>
      <p>
        <b>BikeNow</b> посередній варіант. У них гарні ціні, але незручне для
        мене покриття. Самі самокати непогані, щось середнє між старими{" "}
        <b>Bolt</b> (не дуже важкий, малий) та <b>Jet</b> (є яка не яка але
        стабілізація), але при їзді особисто мені бракує контролю.
      </p>
      <p>
        Я не мав багато досвіду з <b>Zelectra</b> та <b>FlyGo</b>, а про{" "}
        <b>Bird</b> взагалі тільки дізнався (і не дивно бо у них мала зона
        покриття і коли дивився, то був один вільний самокат). Тому як буду мати
        шанс їх потестити, то додам свою думку.
      </p>
      <p>
        <b>TL;DR</b> Поспішаєш? <b>Jet</b> Ні? <b>Bolt</b>.
      </p>
    </TextBlock>
  </section>
);
